import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import global_en from '../translation/en/global.json';
import global_sr from '../translation/sr/global.json';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { global: global_en },
      sr: { global: global_sr },
    },
    lng: 'sr',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
